import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MDEditor from '@uiw/react-md-editor';
import './ArticlesGallery.css';

function ArticlesGallery() {
  const [articles, setArticles] = useState([]);

 useEffect(() => {
  fetch(`${process.env.REACT_APP_API_URL}/api/articles`)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json();
    })
    .then((data) => setArticles(data))
    .catch((err) => console.error('Erreur:', err));
}, []);


  return (
    <div className="articles-page">
      <h1 className="articles-header">Le Magasin de Syphax Hotel</h1>
      <div className="articles-grid">
  {articles.map((article) => (
    <div key={article._id} className="article-wrapper">
      <Link to={`/articles/${article._id}`} className="article-link">
        <div className="article-card">
          <img src={article.mainImage} alt={article.title} className="article-image" />
          <div className="card-text">
            <small className="article-date">{new Date(article.date).toLocaleDateString()}</small>
            <h3 className="article-title">{article.title}</h3>
          </div>
        </div>
      </Link>

      <div className="article-excerpt">
        <MDEditor.Markdown
          source={article.content.slice(0, 120) + '...'}
          style={{
            whiteSpace: 'pre-wrap',
            background: 'white',
            padding: '10px',
            borderRadius: '6px',
            fontSize: '0.85rem',
            color: '#333',
          }}
        />
      </div>
    </div>
  ))}
</div>

    </div>
  );
}

export default ArticlesGallery;
